import {ChangeDetectorRef, Component, OnInit, signal, WritableSignal, ChangeDetectionStrategy} from '@angular/core';
import {NgClass} from '@angular/common';
import {BellPopupComponent} from '@components/bell/bell-popup/bell-popup.component';
import {PushNotificationService} from '@services/push-notification.service';
import {AuthService} from '@services/auth.service';
import {TranslatePipe} from '@ngx-translate/core';

@Component({
	selector: 'peps-bell',
	imports: [
		NgClass,
		BellPopupComponent,
		TranslatePipe
	],
	templateUrl: './bell.component.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrl: './bell.component.css'
})
export class BellComponent implements OnInit {

	constructor(
		private readonly pushNotificationService: PushNotificationService,
		private readonly authService: AuthService,
		private readonly cdr: ChangeDetectorRef
	) {}

	async ngOnInit() {
		if(this.authService.isAuthenticated()) {
			this.isBetaTester = signal(this.authService.isBetaTester());
		}
		this.isSubscribed = await this.pushNotificationService.isSubscribed();
	}

	isOpen = signal(false);
	isBetaTester = signal(false);
	isSubscribed: boolean = false;

	toggle() {
		this.isOpen.set(!this.isOpen());
	}

	close() {
		this.isOpen.set(false);
	}

	enableNotifications() {
		this.pushNotificationService.subscribeToNotifications().then(subscribe => {
			this.isSubscribed = subscribe;
			this.cdr.detectChanges();
		});
	}

	disableNotifications() {
		this.pushNotificationService.unsubscribe().then(unsubscribe => {
			this.isSubscribed = !unsubscribe;
			this.cdr.detectChanges();
		});
	}



}
